import { useCallback } from "react";
import { useDropzone } from "react-dropzone";

type LogoUploadProps = {
  src?: string;
  alt?: string;
  onDrop?: (file: File) => void;
};

const ACCEPTED_LOGO_TYPES = {
  "image/*": [".jpg", ".jpeg", ".png"],
};

export const LogoUpload = ({ src, alt, onDrop }: LogoUploadProps) => {
  const handleDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles[0]) onDrop?.(acceptedFiles[0]);
    },
    [onDrop]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    multiple: false,
    disabled: !onDrop,
    accept: ACCEPTED_LOGO_TYPES,
  });

  return (
    <div
      {...getRootProps({
        className:
          "t-flex t-items-center t-justify-center t-w-[124px] t-h-11 t-rounded-md t-border t-border-dashed t-border-neutral-20 t-bg-surface-lighter-grey t-cursor-pointer t-overflow-hidden",
      })}
    >
      <input {...getInputProps()} />
      {src ? (
        <img src={src} alt={alt} className="t-size-full t-object-contain" />
      ) : (
        <span className="t-text-body-sm t-text-text-30">Upload logo</span>
      )}
    </div>
  );
};
